// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3LWiZ","name":"Header_name__3IKkA","birthday":"Header_birthday__1EdN5","skeleton":"Header_skeleton__2goDI"};